import produce from 'immer'
import {CustomerForm} from "../../../../../types/forms"
import {sanitizeCardNumber} from "../../../../../services/card/sanitize/sanitize-card-number"

export const sanitizeInput = (values: CustomerForm): CustomerForm => {
    return produce(values, (draft) => {
        draft.card.number = sanitizeCardNumber(draft.card.number)
    })
}
